import '../styles/index.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';
import myAccount from "./my-account";
import languagePopup from "./language-popup";
import miniCart from "./mini-cart";

function scrollToNotices() {
    const notices = document.querySelector( '.woocommerce-notices-wrapper, .woocommerce-error, .woocommerce-message' );
    if ( notices ) {
        notices.scrollIntoView( { behavior: 'smooth', block: 'center' } );
    }
}

class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener('load', function () {
            scrollToNotices();
        });
    }

    onDOMLoaded() {

        document.addEventListener('DOMContentLoaded', function () {
            myAccount.init();
            languagePopup.init();
            miniCart.init();
            // Single product – "sposób zamawiania" (wizualny wybór, nie wpływa na koszyk)
            document.querySelectorAll('.fre-order-option').forEach(function (el) {
                el.addEventListener('click', function () {
                    var group = el.closest('[data-order-options]');
                    if (!group) return;
                    group.querySelectorAll('.fre-order-option').forEach(function (o) {
                        o.classList.remove('is-selected');
                    });
                    el.classList.add('is-selected');
                });
            });

            // Clients logo carousel
            if ($.fn.slick) {
                $('.js-clients-slider').slick({
                    infinite:       true,
                    slidesToShow:   5,
                    slidesToScroll: 1,
                    autoplay:       true,
                    autoplaySpeed:  2500,
                    speed:          600,
                    arrows:         false,
                    dots:           false,
                    pauseOnHover:   true,
                    responsive: [
                        { breakpoint: 1280, settings: { slidesToShow: 4 } },
                        { breakpoint: 1024, settings: { slidesToShow: 3 } },
                        { breakpoint: 640,  settings: { slidesToShow: 2 } },
                        { breakpoint: 400,  settings: { slidesToShow: 1 } },
                    ],
                });

                // Hero block slider (image + headline/text/CTA per slide)
                $('.js-hero-slider').slick({
                    infinite:       true,
                    slidesToShow:   1,
                    slidesToScroll: 1,
                    arrows:         false,
                    dots:           true,
                    fade:           true,
                    autoplay:       true,
                    autoplaySpeed:  5000,
                    speed:          600,
                    pauseOnHover:   true,
                });

                // Product groups archive: hero image slider (no headings/text)
                $('.js-products-info-slider').slick({
                    infinite:       true,
                    slidesToShow:   1,
                    slidesToScroll: 1,
                    arrows:         false,
                    dots:           true,
                    fade:           true,
                    autoplay:       true,
                    autoplaySpeed:  4000,
                    speed:          600,
                });

                $('.js-featured-slider').slick({
                    infinite:       false,
                    slidesToShow:   4,
                    slidesToScroll: 1,
                    arrows:         true,
                    dots:           false,
                    responsive: [
                        { breakpoint: 1280, settings: { slidesToShow: 3, dots: false, arrows: true } },
                        { breakpoint: 1024, settings: { slidesToShow: 2, dots: false, arrows: true } },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow:   1,
                                slidesToScroll: 1,
                                dots:           true,
                                arrows:         false,
                            }
                        },
                    ],
                });
            }
        });
    }

    onResize() {
        window.addEventListener('resize', function () {});
    }

    onScroll() {
        window.addEventListener('scroll', function () {});
    }

}

new Main();


